import { ReactNode } from "react";
import { useLoaderData } from "@remix-run/react";
import { gearsLoader } from "@made-people/gears-remix";
import {
  AlgoliaSearchPayload,
  AlgoliaSearchResultsProvider,
} from "@made-people/grease-algolia";
import { CategoryFaq } from "../faq/category-faq";

export const MissMaryAlgoliaSearchResultsProvider = ({
  payload,
  children,
}: {
  payload: AlgoliaSearchPayload;
  children: ReactNode;
}) => {
  const { pageResponse } = useLoaderData<typeof gearsLoader>();
  const page = pageResponse?.page;
  const categoryData =
    page?.pageType === "storyblokPage" ? page?.categoryData : undefined;
  const categoryFaq = categoryData?.faq_category;
  const category = categoryData?.uri;

  return (
    <>
      <AlgoliaSearchResultsProvider payload={payload}>
        {children}
      </AlgoliaSearchResultsProvider>
      <CategoryFaq faq={categoryFaq} category={category} />
    </>
  );
};
